/**
 * 项目默认配置项
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 */

export default {
  // vue-ls options
  storageOptions: {
    namespace: 'xingfugongshe_', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local' // storage name session, local, memory
  }
}



// WEBPACK FOOTER //
// ./src/defaultSettings.js